// Утилиты для хеширования

/**
 * Создает hash от URL для использования в качестве ключа
 * @param {string} url - URL для хеширования
 * @returns {string} - hash строка
 */
export function createUrlHash(url) {
    let hash = 0;
    if (url.length === 0) return hash.toString();
    for (let i = 0; i < url.length; i++) {
        const char = url.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash).toString(36);
}
